import React from "react";
import { useAtom } from "jotai";
import { motion } from "framer-motion";
import { themeAtom } from "../../../../../-Atoms";
import Box from "@mui/material/Box";

import UniversalTextField from "../../../../../GlobalComponents/UniversalTextField";

const ExtrasV2 = ({
  cStrings,
  setCStrings,
  nippleCovers,
  setNippleCovers,
  printedPages,
  setPrintedPages,
  jobData,
}) => {
  const [theme] = useAtom(themeAtom);


  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: [0.25, 0.1, 0.25, 1.0],
      },
    },
  };

  return (
    <motion.div variants={itemVariants}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          borderRadius: "10px",
          backgroundColor:
            theme === "dark" ? "rgba(35,35,35,0.7)" : "rgba(235,235,235,0.9)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow:
            theme === "dark"
              ? "0 2px 10px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.1)"
              : "0 2px 10px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.5)",
          padding: 2,
          marginBottom: 2,
        }}
      >
        
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexWrap: "wrap"
        }}>
          <UniversalTextField
            collectionName="JobData"
            docId={jobData.id}
            fieldName="cStrings"
            value={cStrings || ""}
            label="C-Strings"
            onCallback={(newValue) => {
              // Only allow numeric values
              const numericValue = newValue.replace(/[^0-9]/g, "");
              setCStrings(numericValue);
              return numericValue;
            }}
            sx={{ 
              width: { xs: "100%", sm: "30%" },
              marginTop: 0,
              "& .MuiInputBase-root": {
                fontSize: "15px"
              },
              "& .MuiInputLabel-root": {
                fontSize: "15px"
              }
            }}
          />
          
          <UniversalTextField
            collectionName="JobData"
            docId={jobData.id}
            fieldName="nippleCovers"
            value={nippleCovers || ""}
            label="Nipple Covers"
            onCallback={(newValue) => {
              // Only allow numeric values
              const numericValue = newValue.replace(/[^0-9]/g, "");
              setNippleCovers(numericValue);
              return numericValue;
            }}
            sx={{ 
              width: { xs: "100%", sm: "30%" },
              marginTop: 0,
              "& .MuiInputBase-root": {
                fontSize: "15px"
              },
              "& .MuiInputLabel-root": {
                fontSize: "15px"
              }
            }}
          />
          
          <UniversalTextField
            collectionName="JobData"
            docId={jobData.id}
            fieldName="printedPages"
            value={printedPages || ""}
            label="Printed Pages"
            onCallback={(newValue) => {
              // Only allow numeric values
              const numericValue = newValue.replace(/[^0-9]/g, "");
              setPrintedPages(numericValue);
              return numericValue;
            }}
            sx={{ 
              width: { xs: "100%", sm: "30%" },
              marginTop: 0,
              "& .MuiInputBase-root": {
                fontSize: "15px"
              },
              "& .MuiInputLabel-root": {
                fontSize: "15px"
              }
            }}
          />
        </Box>
      </Box>
    </motion.div>
  );
};

export default ExtrasV2;